import React from "react";

export default function ItemFeedback({ coachFeedback, programFeedback }) {
  let feedback = coachFeedback;

  return (
    <>
      <p className="auto-height">{feedback.text}</p>
      <div className="text-date">
        <i>{feedback.date}</i>
      </div>
    </>
  );
}
